import React, { useMemo } from 'react';
import { HuchaPosventaValues } from '../../shared/models/hucha-values';
import { PdfBonoPosventa } from '../components/pdf/pdf-bono-posventa';
import { BonoPosventaPopup } from '../components/popup/popup-bono-posventa';

export const useHuchaPosventaLayerContent = (huchaValues: HuchaPosventaValues | null) => {
	const huchaPosventaPopupLayerContent = useMemo(() => {
		return <BonoPosventaPopup huchaValues={huchaValues} />;
	}, [huchaValues]);

	const huchaPosventaPdfLayerContent = useMemo(() => {
		return <PdfBonoPosventa huchaValues={huchaValues} />;
	}, [huchaValues]);

	return { huchaPosventaPopupLayerContent, huchaPosventaPdfLayerContent };
};
